import { Input, createStyles, Container, Title, Text, Button, rem, BackgroundImage, Image, SimpleGrid, Group, Grid, TextInput, Paper, Anchor,  Select, Avatar, Space, Flex, Modal, Alert, useMantineTheme } from '@mantine/core';
import Autoplay from 'embla-carousel-autoplay';
import { IconChevronDown, IconBrandWhatsapp } from '@tabler/icons-react';
import { useMediaQuery, useScrollIntoView } from '@mantine/hooks';
import patern from'./patern.png';
import logoKananAtas from'./logo-kanan-atas.png';
import logoBawahKanan from'./outlet.png';
import logoBawahKiri from'./logo-trans.png';
import autoPilot from'./autopilot.png';
import balikModal from'./balikmodal.png';
import mulaidari from'./mulaidari.png';
import omzet from'./omzet.png';
import profit from'./profit.png';
import fastgrowing from'./fastgrowing.png';
import berpengalaman from'./berpengalaman.png';
import bgForm from'./bgform.png';
import bg from'./bg.png';
import { Carousel } from '@mantine/carousel';
import facebook from './facebook.png';
import instagram from './instagram.png';
import linkedin from './linkedin.png';
import whatsapp from './whatsapp.png';
import youtube from './youtube.png';
import tiktok from './tiktok.png';

import fithub from './Logo-Fit-Hub.png';
import ghg from './Logo-GHG.png';
import golden from './Logo-Golden-Lamian.png';
import sozo from './Logo-Sozo.png';
import teatalk from './Logo-TeaTalk.png';

import gallery_1 from './gallery_1.jpg';
import gallery_2 from './gallery_2.jpg';
import gallery_3 from './gallery_3.jpg';
import gallery_4 from './gallery_4.jpg';

import React, { useRef, useState } from 'react';
import { useId } from '@mantine/hooks';
import { IMaskInput } from 'react-imask';
import axios from "axios";



const useStyles = createStyles((theme) => ({
  root: {
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: '450px',
  },

  video: {
    borderRadius : '20px',
    overflow : 'hidden',
    WebkitTransform : 'translatez(0)',
    boxShadow : '0 19px 51px 0 rgba(0,0,0,0.16), 0 14px 19px 0 rgba(0,0,0,0.07)',

  },

  abosolute: {
    position: 'absolute',
    margin: '0 0 0 35%',
    border: '3px solid #FAB005!important',
    [theme.fn.smallerThan('md')]: {
      margin: '0 0 0 35%',
    },
  },

  logoatas: {
    position: 'absolute',
        top: '0px',
        right: '0px',
  },

  logobawahkanan: {
    position: 'absolute',
    width: '450px!important',
        bottom: '0px',
        right: '0px',
        [theme.fn.smallerThan('md')]: {
          flexDirection: 'column',
          width: '250px!important',
        },
  },

  logobawahkiri: {
    position: 'absolute',
        bottom: '-100px',
        left: '-100px',
  },


  inner: {
    display: 'flex',
    justifyContent: 'space-between',

    [theme.fn.smallerThan('md')]: {
      flexDirection: 'column',
    },
  },

  image: {
    [theme.fn.smallerThan('md')]: {
      display: 'none',
    },
  },

  content: {
    paddingTop: `calc(${theme.spacing.xl} * 2)`,
    paddingBottom: `calc(${theme.spacing.xl} * 2)`,
    marginRight: `calc(${theme.spacing.xl} * 3)`,
    [theme.fn.smallerThan('md')]: {
      marginRight: 0,
    },
  },

  title: {
    color: "#9c1e21",
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontWeight: 900,
    lineHeight: 1.35,
    maxWidth: rem(500),
    fontSize: rem(50),
    [theme.fn.smallerThan('md')]: {
      maxWidth: '100%',
      fontSize: rem(34),
      lineHeight: 1.15,
    },
  },

  titleSection: {
    color: "#9c1e21",
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontWeight: 900,
    lineHeight: 1.35,
    fontSize: rem(35),

    [theme.fn.smallerThan('md')]: {
      maxWidth: '100%',
      fontSize: rem(34),
      lineHeight: 1.15,
    },
  },

  description: {
    color: "#9c1e21",
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontWeight: 500,
    lineHeight: 1.35,
    fontSize: rem(13),

    [theme.fn.smallerThan('md')]: {
      maxWidth: '100%',
    },
  },

  control: {
    paddingLeft: rem(50),
    paddingRight: rem(50),
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontSize: rem(22),

    [theme.fn.smallerThan('md')]: {
      width: '100%',
    },
  },
}));

function App() {

  const { classes } = useStyles();

  let url = 'https://goldenlamian.com/assets/locations.mp4';

  let url1 = 'https://goldenlamian.com/assets/influencer_1.mp4';

  const { scrollIntoView, targetRef } = useScrollIntoView<HTMLDivElement>({
    offset: 60,
    duration: 200
  });

  const autoplay = useRef(Autoplay({ delay: 2000 }));
  const id = useId();

  const [opened, setOpened] = useState(false);
  const [cBoxTitle, setcBoxTitle] = useState('');
  const [cBoxDescription, setcBoxDescription] = useState('');
  const [cBoxColor, setcBoxColor] = useState('');

  const theme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  async function submitContact(event: {
    target: any; preventDefault: () => void; 
  }) {
    event.preventDefault() // Prevent the redirect 
    let nama_lengkap = event.target.nama_lengkap.value as string;
    let email =  event.target.email.value as string;
    let nomor_hp = event.target.nomor_hp.value as string;
    let nominal_investasi =  event.target.nominal_investasi.value as string;
    let brand = 'Golden Lamian';
    let utm_source = (new URLSearchParams(window.location.search)).get("utm_source")  as string;
    let utm_medium = (new URLSearchParams(window.location.search)).get("utm_medium")  as string;
    let utm_campaign = (new URLSearchParams(window.location.search)).get("utm_campaign")  as string;
    let utm_id = (new URLSearchParams(window.location.search)).get("utm_id")  as string;
    let utm_term = (new URLSearchParams(window.location.search)).get("utm_term")  as string;

  window.location.replace('https://goldenlamian.com/kemitraan/loading.php?nama_lengkap='+nama_lengkap+'&email='+email+'&nomor_hp='+nomor_hp+'&nominal_investasi='+nominal_investasi+'&brand='+brand+'&utm_source='+utm_source+'&utm_medium='+utm_medium+'&utm_campaign='+utm_campaign+'&utm_id='+utm_id+'&utm_term='+utm_term);

      
  }; 


  return (
    <>
    <Modal centered 
        opened={opened}
        onClose={() => setOpened(false)}
        title={cBoxTitle}
>
<Alert  color={cBoxColor}>
{cBoxDescription}
    </Alert>
</Modal>

    <BackgroundImage
    src={patern}
    radius="sm"
  >
    <div className={classes.root}>
         <Image src={logoKananAtas} width={150} className={classes.logoatas}/>
    <Container size="lg">
      <div className={classes.inner}>
        <div className={classes.content}>
        <Space h="xl" />
          <Title className={classes.title}>
            <Text
              component="span"
              inherit
            >
              MILIKI OUTLET
            </Text>
          </Title>
          <Title className={classes.title}>
            <Text 
              component="span"
              inherit
            >
              GOLDEN LAMIAN
            </Text>
          </Title>
          <Title className={classes.title}>
            <Text
              component="span"
              inherit
            >
              SEKARANG !
            </Text>
          </Title>
          <Button onClick={() =>
          scrollIntoView({
            alignment: 'center',
          })
        } mt={20} size="xl" color="red.9" radius="lg" uppercase>
      DAFTAR KEMITRAAN
    </Button>
    <Title className={classes.description} mt={16}>
            <Text 
              component="span"
              inherit
              fs="italic"
            >
              100++ Outlet Seluruh Indonesia
            </Text>
          </Title>
        </div>
      </div>
    </Container>
    <Image src={logoBawahKanan}  className={classes.logobawahkanan}/>
    <Image src={logoBawahKiri} width={250} className={classes.logobawahkiri}/>
  </div>
  </BackgroundImage>
  <BackgroundImage
    src={patern}
    radius="sm"
  >
  <div className={classes.root}>
    <Container size="lg" pt={40}>
          <Text ta="center"  className={classes.titleSection}
            >
              PELUANG BISNIS
            </Text>
            <Text ta="center"  className={classes.titleSection}
            > MENGUNTUNGKAN
            </Text>
            <Space h="xl" />
            <SimpleGrid cols={5} spacing={30} breakpoints={[{ maxWidth: 'md', cols: 1 }]} mt='lg'>
            <div>
            <Image src={autoPilot} width={rem(100)} mx="auto" />
      <Text fz="lg" mt="sm" fw={500}  ta="center" color="#9c1e21">
      AUTO PILOT
      </Text>
      <Text  ta="center" color="#9c1e21">
        Terima Beres
      </Text>
    </div>
    <div>
    <Image src={berpengalaman} width={rem(100)}  mx="auto"/>
       <Text fz="lg" mt="sm" fw={500}  ta="center" color="#9c1e21">
      BERPENGALAMAN
      </Text>
      <Text  ta="center" color="#9c1e21">
        Sejak 2017
      </Text>
    </div>
    <div>
    <Image src={omzet} width={rem(100)}  mx="auto"/>
      <Text fz="lg" mt="sm" fw={500}  ta="center" color="#9c1e21">
       OMZET 500JT/BULAN
      </Text>
    </div>
    <div>
    <Image src={fastgrowing} width={rem(100)}  mx="auto"/>
       <Text fz="lg" mt="sm" fw={500}  ta="center" color="#9c1e21">
      FAST GROWING
      </Text>
      <Text  ta="center" color="#9c1e21">
        100+ outlet seluruh Indonesia
      </Text>
    </div>
    <div>
    <Image src={mulaidari} width={rem(100)}  mx="auto"/>
      <Text fz="lg" mt="sm" fw={500}  ta="center" color="#9c1e21">
       KEMITRAAN MULAI DARI 600JT
      </Text>
    </div>
          </SimpleGrid>
          <Space h="xl" />
          <Space h="xl" />
          <Text color="#9c1e21" fz="xs" align='right'
            >
              *Disclaimer: Perhitungan dan nominal diatas dapat berubah tergantung pemilihan lokasi dan kondisi.
            </Text>
            <Space h="sm" />
         
    </Container>
  </div>
  </BackgroundImage>
  <BackgroundImage
    src={bgForm}
    radius="sm"
  >
     <div className={classes.root}>
    <Container size="lg">
    <Grid>
      <Grid.Col span={6}>
      <div className={classes.inner}>
        <div className={classes.content}>
        <Space h="xl" />
        <Title className={classes.title}>
            <Text
              component="span"
              inherit
              ref={targetRef}
              sx={{
                '@media (max-width: 48em)': {
                  fontSize: '1.8rem',
                },
              }}
            >
              BERGABUNG MENJADI
            </Text>
          </Title>
          <Title className={classes.title}>
            <Text 
              component="span"
              inherit
              sx={{
                '@media (max-width: 48em)': {
                  fontSize: '1.8rem',
                },
              }}
            >
              MITRA KAMI SEKARANG
            </Text>
          </Title>
          <Space h="xs" />
          <Text fz="xl" color="#9c1e21">
      Tim kami akan segera menghubungi Anda
      </Text>
        </div>
      </div>
      </Grid.Col>
      <Grid.Col span={6} mt="xl">
      <div >
      <form
        onSubmit={ submitContact}
      >
        <TextInput label="Nama" placeholder="Nama lengkap"  name="nama_lengkap" required/>
         <Input.Wrapper id={id} label="Nomor hp" required  mx="auto">
      <Input<any>
        component={IMaskInput}
        mask="0000 0000 0000"
        id={id}
        placeholder="Your phone"
        name="nomor_hp"
        required
      />
    </Input.Wrapper>
        <TextInput label="Email" placeholder="Email" name="email" required/>
        <Select
      label="Dana yang dapat dialokasikan"
      placeholder="Pick one"
      rightSection={<IconChevronDown size="1rem" />}
      rightSectionWidth={30}
      styles={{ rightSection: { pointerEvents: 'none' } }}
      defaultValue="100 juta - 500 juta"
      data={['100 juta - 500 juta', '500 juta - 1 miliar ', '> 1 miliar']}
      name="nominal_investasi"
    />
        <Group position="apart" mt="lg" >
        <Button radius="lg" color="red.9" p="10" type="submit">KIRIM</Button>
        </Group>
        </form>
      </div>
      </Grid.Col>
    </Grid>
    </Container>
  </div>
  </BackgroundImage>
  {/* Location Video */}

  <div className={classes.root}>
    <Container size="lg">
    <SimpleGrid cols={2} spacing={30} breakpoints={[{ maxWidth: 'md', cols: 1 }]} mt='lg'>
    <div >
        <Space h="xl" />
        <video playsInline autoPlay muted loop style={{  width: "100%" }} className={classes.video} >
          <source src={url} />
        </video> 
        </div>
        <div >
        <Space h="xl" />
        <video playsInline autoPlay muted loop style={{  width: "100%" }} className={classes.video} >
          <source src={url1} />
        </video> 
        </div>
      </SimpleGrid>
    <Grid>
      <Grid.Col span={12}>
      <div className={classes.inner}>
        <div >
        <Space h="xl" />
        <Text ta="center"  className={classes.titleSection}
            >
              GALERI OUTLET GOLDEN LAMIAN
            </Text>
            <Space h="xl" />
        <Carousel  
        withIndicators
        slideSize="31.533333%"
        height={380}
        slideGap="md"
        align="start"
        dragFree
        breakpoints={[
          { maxWidth: 'md', slideSize: '50%' },
          { maxWidth: 'sm', slideSize: '100%', slideGap: 2 },
        ]}
        slidesToScroll={mobile ? 1 : 2}
      >
        <Carousel.Slide>
      <Image radius="lg" src={gallery_1} />
    </Carousel.Slide>
    <Carousel.Slide >
      <Image radius="lg" src={gallery_2} />
    </Carousel.Slide>
    <Carousel.Slide >
      <Image radius="lg" src={gallery_3} />
    </Carousel.Slide>
    <Carousel.Slide >
      <Image radius="lg" src={gallery_4} />
    </Carousel.Slide>
    <Carousel.Slide>
      <Image radius="lg" src={gallery_1} />
    </Carousel.Slide>
    <Carousel.Slide >
      <Image radius="lg" src={gallery_2} />
    </Carousel.Slide>
    </Carousel>
        </div>
      </div>
      </Grid.Col>
    </Grid>
    </Container>
  </div>
  {/* Location Video */}

  <BackgroundImage
    src={patern}
    radius="sm"
  >
    <div className={classes.root}>
    <Container size="lg" pt={40}>
          <Text ta="center"  className={classes.titleSection}
            >
              PENDAPAT MITRA KAMI TENTANG
            </Text>
            <Text ta="center"  className={classes.titleSection}
            > PELUANG USAHA GOLDEN LAMIAN
            </Text>
            <Carousel
       withControls={false}
       slideSize="31.533333%"
       height={370}
       slideGap="md"
       align="start"
       dragFree
       breakpoints={[
         { maxWidth: 'md', slideSize: '50%' },
         { maxWidth: 'sm', slideSize: '100%', slideGap: 2 },
       ]}
       slidesToScroll={mobile ? 1 : 2}
    >
      <Carousel.Slide>
      <Paper shadow="md" radius="lg" p="xl" m="xs"> 
      <Text ta="center"  color="#9c1e21">
      "Sistem autopilot sangat memudahkan saya yang sibuk dengan bisnis lain. Semua kegiatan operasional dan marketing di tangani oleh tim manajemen yang profesional sehingga saya tidak perlu khawatir.  Keuntungan yang diberikan juga konsisten setiap bulannya. Saya senang menjadi mitra Golden Lamian."
      </Text>
      <Space h="xs" />
      <Text ta="center" color="yellow.7">- Dwi Kasih, owner Golden Lamian Tebet</Text>
      <Space h="xs" />
    <Avatar radius="xl" size="lg" color="yellow" src="#"  className={classes.abosolute}/>
    </Paper>
    </Carousel.Slide>
    <Carousel.Slide>
      <Paper shadow="md" radius="lg" p="xl">
      <Text ta="center" color="#9c1e21">
      "Selama menjadi mitra Golden Lamian saya merasa puas dengan kinerja manajemen. Laporan keuangan rapi, tim cepat tanggap, produk inovatif, dan yang terpenting keuntungan yang konsisten setiap bulannya. Sukses selalu untuk Seven Retail."
      </Text>
      <Space h="xs" />
      <Text ta="center"  color="yellow.7">- Rangga, owner Golden Lamian Grand Indonesia</Text>
      <Space h="xs" />
      <Avatar radius="xl" size="lg" color="yellow" src="#" className={classes.abosolute}/>
    </Paper>
    </Carousel.Slide>
    <Carousel.Slide>
      <Paper shadow="md" radius="lg" p="xl">
      <Text ta="center" color="#9c1e21">
      "Di tengah persaingan bisnis F&B yang ketat, outlet Golden Lamian saya tetap ramai dan menghasilkan omzet &gt; 500jt setiap bulannya."
      </Text>
      <Space h="xs" />
      <Text ta="center"  color="yellow.7">- Anthony, Owner Golden Lamian Kota Kasablanka</Text>
      <Space h="xs" />
      <Avatar radius="xl" size="lg" color="yellow" src="#" className={classes.abosolute}/>
    </Paper>
    </Carousel.Slide>
    </Carousel>
    </Container>
    <Space h="md" />
    <Space h="md" />
    <Space h="md" />
   
  </div>
  </BackgroundImage>

  <BackgroundImage
    src={bg}
    radius="sm"
  >
    <div className={classes.root}>

<Grid>
  <Grid.Col span={6}>
  <Container size="lg">
  <Text ta="center"  fz="xl" mt="sm" fw={700}  color="#9c1e21"
            >
              Hubungi Kami
            </Text>
            <Space h="xs" />
            <Flex
      mih={50}
      gap="md"
      justify="center"
      align="center"
      direction="row"
      wrap="wrap"
    >
       <Anchor href="https://goldenlamian.com/kemitraan/redirect.php" target="_blank">
       <Button color="red.9" radius="xl" size="xl" compact>
      Info kemitraan 0811 814 558
    </Button>
       </Anchor>
  </Flex>
  <Space h="md" />
  <Text ta="center"  fz="xl" mt="sm" fw={700}  color="#9c1e21"
            >
              Follow Us
            </Text>
            <Space h="xs" />
            <Flex
      mih={50}
      gap="md"
      justify="center"
      align="center"
      direction="row"
      wrap="wrap"
    >
      <Anchor href="https://www.tiktok.com/@golden.lamian" target="_blank">
    <Image src={tiktok} width={rem(40)} />
    </Anchor>
    <Anchor href="https://api.whatsapp.com/send?phone=62811814558&text=Halo%21%20Saya%20ingin%20bertanya%20info%20kemitraan%20Golden%20Lamian.&utm_source=website&utm_medium=directcontact&utm_campaign=whatsapp" target="_blank">
    <Image src={whatsapp} width={rem(40)} />
    </Anchor>
    <Anchor href="https://www.youtube.com/@goldenlamian8616" target="_blank">
      <Image src={youtube} width={rem(40)} />
      </Anchor>
      <Anchor href="https://www.facebook.com/goldenlamian.id/?locale=id_ID" target="_blank">
      <Image src={facebook} width={rem(40)} />
      </Anchor>
      <Anchor href="https://goldenlamian.com" target="_blank">
      <Image src={linkedin} width={rem(40)} />
      </Anchor>
      <Anchor href="https://www.instagram.com/goldenlamian/?hl=en" target="_blank">
      <Image src={instagram} width={rem(40)} />
      </Anchor>
    </Flex>
    <Space h="md" />
    <Text ta="center"  fz="xl" mt="sm" fw={700}  color="#9c1e21"
            >
              Our Brands
            </Text>
            <Space h="xs" />

            <Flex
      mih={50}
      gap="md"
      justify="center"
      align="center"
      direction="row"
      wrap="wrap"
    >
      <Image src={golden} width={rem(50)} />
      <Image src={sozo} width={rem(50)} />
      <Image src={ghg} width={rem(50)} />
      <Image src={fithub} width={rem(50)} />
      <Image src={teatalk} width={rem(50)} />
    </Flex>

</Container>
  </Grid.Col>
  <Grid.Col span={6}>
  <Container size="lg" >
  <div >
  <Text ta="center"  fz="xl" mt="sm" fw={700}  color="gray.0"
            >
              Seven Retail Group
            </Text>
            <Space h="xs" />
            <Text   color="#fff">
            Jl. Bintaro Raya No.15, RT.11/RW.10, Kebayoran Lama Selatan, Kecamatan Kebayoran Lama, Jakarta Selatan, DKI Jakarta 12240
      </Text>
      <Space h="xs" />
      <Anchor href="http://seven-retail.com/" target="_blank">
            <Text ta="center"  fz="xl" mt="sm" fw={700}  color="gray.0"
            >
              Tentang Seven Retail
            </Text>
            </Anchor>
            <Space h="xs" />
            <Anchor href="https://goldenlamian.com/kemitraan/kebijakanprivasi/" target="_blank">
            <Text ta="center"  fz="xl" mt="sm" fw={700}  color="gray.0"
            >
              Kebijakan Privasi
            </Text>
            </Anchor>
            <Anchor href="https://goldenlamian.com/kemitraan/redirect.php" target="_blank">
            <Button color="green" radius="xl" leftIcon={<IconBrandWhatsapp size="1.57rem" />} style={{    position: 'fixed', bottom: '1.25rem', right: '1.25rem'}}>
             <Text  fz="xl" fw={700} 
            >
            Info Kemitraan 0811 814 558
            </Text>
         
          </Button>
            </Anchor>
            <Space h="xl" />
            <Space h="xl" />
            <Space h="xl" />
            <Space h="xl" />
            <Text  ta="center" color="#fff">
            &#169; 2017 - 2023, PT. Seven Retail Group
      </Text>
  </div>
</Container>
  </Grid.Col>
</Grid>
</div>
  </BackgroundImage>
  <div>
  <Space h="xs" />
            <Text ta="center" >
            Tags: franchise, kemitraan, peluang usaha, peluang bisnis, bisnis kuliner, bisnis franchise, franchise golden lamian
            </Text>
             <Text ta="center" >
             Golden Lamian merupakan restoran Lamian halal no. 1 di Indonesia sejak tahun 2017. Golden Lamian menawarkan peluang usaha kemitraan dengan sistem auto pilot (seperti konsep bisnis franchise). Kelebihan dari kemitraan Golden Lamian adalah semua kegiatan operasional dan bisnis di tangani langsung oleh tim profesional (auto pilot), produk bersertifikasi halal, dan menu inovatif dengan rasa konsisten. Dengan bergabung kemitraan Golden Lamian, mitra bisa mendapatkan omzet rata-rata 500jt/bulan dengan rata-rata balik modal 3-4 tahun. Hal ini menjadikan Golden Lamian menjadi peluang bisnis yang menjanjikan atau peluang usaha menguntungkan bagi masyarakat yang sedang mencari ide bisnis, ingin franchise makanan / usaha franchise, atau ingin punya bisnis tapi tidak ada waktu untuk mengurus operasional bisnis.
             </Text>
              <Text ta="center" >
              Golden Lamian sudah dipercaya oleh lebih dari 80 mitra di seluruh Indonesia dengan total outlet lebih dari 100 di seluruh Indonesia dan terus bertumbuh.
              </Text>
  </div>
    
  </>
  );
}

export default App;

